import "./style.css";
import { t } from "../../services/formatters";
import { Consenso } from "../Consenso";
import { useSession } from "../../hooks/useSession";

export const Informative = ({}) => {
  const { read, update } = useSession();

  const scrollToNextElement = (destinationIdx = null) => {
    // default to "fissa" button
    let destinationNode = document.querySelector(".btn-txt-container");
    if (null != destinationIdx) {
      destinationNode = document.querySelectorAll(".tos-item-component__header input[type=radio]")[destinationIdx];
    }
    destinationNode.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <div className="section tos-list-component">
      <h3>{t("we_need_your_consent_1")}</h3>
      <br />
      <p className="" dangerouslySetInnerHTML={{ __html: t("prendi_visione") }}></p>

      <div className={`section white-box input-box-component`}>
      <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
        <Consenso
          defaultValue={read("privacyExtcommoffer")}
          onChange={(value) => {
            update("privacyExtcommoffer", value);
            scrollToNextElement(2);
          }}
          name="privacyExtcommoffer"
          text={t("tos_1")}
        />
        <hr />
        <Consenso
          defaultValue={read("privacyOtherservice")}
          onChange={(value) => {
            update("privacyOtherservice", value);
            scrollToNextElement(4);
          }}
          name="privacyOtherservice"
          text={t("tos_2")}
        />
        <hr />
        <Consenso
          defaultValue={read("privacyProfilazione")}
          onChange={(value) => {
            update("privacyProfilazione", value);
            scrollToNextElement(6);
          }}
          name="privacyProfilazione"
          text={t("tos_3")}
        />
        <hr />
        
        <p className="crea-appto-error tos-list-component-sic-appto-error text-center hidden"><br />È obbligatorio il consenso.</p>
        <Consenso
          defaultValue={read("privacyInterncommoffer")}
          onChange={(value) => {
            update("privacyInterncommoffer", value);
            scrollToNextElement();
          }}
          name="privacyInterncommoffer"
          text={t("tos_4")}
          classList="tos-sic"
        />
      </div>
    </div>
  );
};
